/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Billing_Board_Invoiced_SubInputs */



/**
* | output |
* | --- |
* | "Invoice sent, payment not received · {count} invoices" |
*
* @param {Partner_Billing_Board_Invoiced_SubInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_invoiced_sub = /** @type {((inputs: Partner_Billing_Board_Invoiced_SubInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Invoiced_SubInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Rechnung versendet, Zahlung nicht eingegangen · ${i?.count} Rechnungen`)
	return /** @type {LocalizedString} */ (`Invoice sent, payment not received · ${i?.count} invoices`)
});